import { render, staticRenderFns } from "./PrintSetting.vue?vue&type=template&id=0fc4a806&scoped=true&"
import script from "./PrintSetting.vue?vue&type=script&lang=js&"
export * from "./PrintSetting.vue?vue&type=script&lang=js&"
import style0 from "./PrintSetting.vue?vue&type=style&index=0&id=0fc4a806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc4a806",
  null
  
)

export default component.exports